import React from 'react';
import { styled } from '@components-shared/src/stitches';

export const EmptyState = () => (
  <EmptyStateContainer>
    <Mask />
    <EmptyText>No Activity</EmptyText>
  </EmptyStateContainer>
);

const EmptyStateContainer = styled('div', {
  position: 'relative',
  width: '100%',
  height: 200,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: 40,
});

const Mask = styled('div', {
  position: 'absolute',
  top: 0,
  left: 0,
  maskImage: 'url(/star.png)',
  maskSize: '34px',
  background:
    'radial-gradient(60% 80% at 5% 10%, rgba(255, 255, 255, 0) 0%, #FFFFFF 80%), rgba(0,0,0, 0.5)',
  transform: 'rotate(180deg) matrix(-1, 0, 0, 1, 0, 0)',
  width: '100%',
  height: '100%',
});

const EmptyText = styled('div', {
  position: 'relative',
  fontSize: 18,
  fontWeight: 400,
  color: '$neutral400',
  textAlign: 'center',
  marginTop: -90,
});
